import { render, staticRenderFns } from "./FaceRecognition.vue?vue&type=template&id=51241cff&scoped=true&"
import script from "./FaceRecognition.vue?vue&type=script&lang=js&"
export * from "./FaceRecognition.vue?vue&type=script&lang=js&"
import style0 from "./FaceRecognition.vue?vue&type=style&index=0&id=51241cff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51241cff",
  null
  
)

export default component.exports